import invariant from 'tiny-invariant'
import { StepsMap } from '../atoms'
import { WatchtowerSteps } from '../components/steps'

/**
 * A safe stepData getter that will also appease TS!
 */
export const getStepData =
  (steps: StepsMap) =>
  <K extends WatchtowerSteps['step']>(step: K) => {
    const stepData = steps.getData(step)
    invariant(stepData, `No data found for step: ${step}`)
    return stepData
  }
